// extracted by mini-css-extract-plugin
module.exports = {"postImg":"style_postImg__wBOLx","caption":"style_caption__HXv3m","titleContent":"style_titleContent__6AUQm"};